export default __webpack_public_path__ + "static/media/deleteButton.90a4794c.svg";